import styled from 'styled-components'

export const FormSectionTitle = styled.h3`
  color: ${({ theme }) => theme.palette.content.contrastText};
  font-weight: 500;
  font-size: 1.325rem;
`
